import { render, staticRenderFns } from "./TiposDespesa.vue?vue&type=template&id=4c757ed6&"
import script from "./TiposDespesa.vue?vue&type=script&lang=js&"
export * from "./TiposDespesa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports